module.exports = __webpack_public_path__ + "img/03.ad43a2f5.webp";